import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'
import '@/axios/api'
const app = createApp(App)
import zhCn from 'element-plus/es/locale/lang/zh-cn';
app.use(ElementPlus, { locale: zhCn });
app.config.warnHandler = () => undefined;
app.config.errorHandler = (err, instance, info) => {
  const errorMessage = err instanceof Error ? err.message : String(err);
  // 检查错误信息是否包含目标关键字
  const ignoreKeywords = ['Cannot read properties of undefined (reading \'path\')'];
  const shouldIgnore = ignoreKeywords.some(keyword => errorMessage.includes(keyword));

  if (!shouldIgnore) {
    console.error('Global error:', err, instance, info);
  }
};
  
 

// app.use(ElementPlus) // 使用 ElementPluVue s  // 小任设置的 英文 环境 必要时可以换回来
app.use(store) // 使用 Vuex store
app.use(router) // 使用 Vue Router
app.mount('#app') // 挂载到 DOM
